module.exports = __webpack_public_path__ + "img/dataset.87b512af.svg";